import { connect, Dispatch } from 'react-redux';
import { AppState } from 'src';
import {
  FailedEmailComponentProperties,
  FailedEmailComponent
} from 'src/failed-email/_components/failed-email.component';
import {
  searchFailedEmailList,
  changeFailedEmailOwnership,
  setFailedEmailLoading,
  getFailedEmailList,
  removeFailedEmail
} from 'src/failed-email/failed-email.actions';
import { toggleDialog, toggleModal, doAsync } from '@common/components/common.actions';
import { ModalProps } from '@common/components';

function mapStateToProps(state: AppState, ownProps: {}): Partial<FailedEmailComponentProperties> {
  return {
    emailList: state.failedEmailState.emailList,
    message: state.failedEmailState.message,
    query: state.failedEmailState.query,
    loading: state.failedEmailState.loading,
    pageCount: state.failedEmailState.pageCount,
    pageNumber: state.failedEmailState.pageNumber,
    pageSize: state.failedEmailState.pageSize,
    user: state.auth.currentProfile
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: {}): Partial<FailedEmailComponentProperties> {
  return {
    getEmailList(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, query?: string) {
      dispatch(searchFailedEmailList(pageSize, pageNumber, orderBy, orderDirection, query));
    },
    toggleDialog: (comment: string) => {
      dispatch(toggleDialog({ textYes: 'Close', text: comment, onYesClick: () => toggleDialog() }));
    },
    toggleModal: (modalProps?: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    handleOwnershipChange: async (id: number, release: boolean) => {
      await dispatch(doAsync(setFailedEmailLoading(true)));
      await dispatch(changeFailedEmailOwnership(id, release));
      await dispatch(getFailedEmailList());
      await dispatch(doAsync(setFailedEmailLoading(false)));
    },
    handleRemove: async (id: number) => {
      await dispatch(doAsync(setFailedEmailLoading(true)));
      await dispatch(removeFailedEmail(id));
      await dispatch(getFailedEmailList());
      await dispatch(doAsync(setFailedEmailLoading(false)));
    }
  };
}

export const FailedEmail = connect(
  mapStateToProps,
  mapDispatchToProps
)(FailedEmailComponent);



// WEBPACK FOOTER //
// ./src/failed-email/_components/failed-email.container.tsx